import React from 'react';

const ButtonRadio = (props) => (
    <div className={props.type === "checkbox" ? "form-check" : "custom-control custom-radio"}>
        <input
            type={props.type}
            id={props._id}
            name={props.name}
            className={props.type === "checkbox" ? "form-check-input "+props._className : "custom-control-input "+props._className}
            value={props.value}
            checked={props.checked}
            onChange={props.onChange}
        />
        <label
            className={props.type === "checkbox" ? "form-check-label" : "custom-control-label"}
            htmlFor={props._id}>{props.label ? props.label : props.value}
        </label>
    </div>
)

export default ButtonRadio;


// WEBPACK FOOTER //
// ./src/components/Common/ButtonRadio.js